import React from 'react';
import {
  VIRGINIA_TRIBUTE_PATTERN_IMAGE,
  WEST_VIRGINIA_TRIBUTE_PATTERN_IMAGE,
} from '../lib/virginiaTribute';

const VA_PHOTO = `${process.env.PUBLIC_URL}/assets/virginia-tribute/virginia-combs.jpg`;
const WV_PHOTO = `${process.env.PUBLIC_URL}/assets/virginia-tribute/virginia-combs-west.jpg`;

const OVERLAYS = [
  ['gray', '#ECEFF1', 0.58],
  ['orange', '#FF5722', 0.48],
  ['green', '#2E7D32', 0.52],
];

function TributePatterns({ idPrefix, photo, image, preserveAspectRatio }) {
  const { x, y, width, height } = image;
  return OVERLAYS.map(([name, overlay, overlayOpacity]) => (
    <pattern
      key={`${idPrefix}-${name}`}
      id={`${idPrefix}-${name}`}
      patternContentUnits="objectBoundingBox"
      width="1"
      height="1"
    >
      <image
        href={photo}
        x={x}
        y={y}
        width={width}
        height={height}
        {...(preserveAspectRatio ? { preserveAspectRatio } : {})}
      />
      <rect width="1" height="1" fill={overlay} fillOpacity={overlayOpacity} />
    </pattern>
  ));
}

/**
 * SVG patterns for Virginia (FIPS 51) and West Virginia (FIPS 54) when the family tribute is enabled.
 * Each image is clipped to that state's path via pattern fill on the Geography element.
 */
export default function VirginiaTributePatternDefs() {
  return (
    <defs>
      <TributePatterns idPrefix="platechase-va-tribute" photo={VA_PHOTO} image={VIRGINIA_TRIBUTE_PATTERN_IMAGE} />
      <TributePatterns
        idPrefix="platechase-wv-tribute"
        photo={WV_PHOTO}
        image={WEST_VIRGINIA_TRIBUTE_PATTERN_IMAGE}
        preserveAspectRatio="none"
      />
    </defs>
  );
}
